import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';
import { GlowCard } from '../components/GlowCard.js';

export default function LoginPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const { error: err } = await signIn(email, password);
    setLoading(false);
    if (err) {
      setError(err);
    } else {
      navigate('/dashboard');
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-pix-void px-4">
      <div className="w-full max-w-sm">
        {/* Branding */}
        <div className="mb-8 text-center">
          <div className="mb-2 flex items-center justify-center gap-2 text-xs text-white/30">
            <span className="font-bold tracking-widest uppercase">PIX3L</span>
            <span>/</span>
            <span>Cascade</span>
          </div>
          <h1 className="text-2xl font-bold text-white">Sign in</h1>
          <p className="mt-1 text-sm text-white/40">Welcome back.</p>
        </div>

        <GlowCard className="rounded-2xl border border-white/5 bg-pix-deep p-8">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="email" className="block text-xs font-medium uppercase tracking-wider text-white/40">
                Email
              </label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 block w-full rounded-lg border border-white/10 bg-pix-void px-3 py-2.5 text-sm text-white placeholder-white/20 focus:border-pix-pink/50 focus:outline-none focus:ring-1 focus:ring-pix-pink/50"
              />
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-xs font-medium uppercase tracking-wider text-white/40">
                  Password
                </label>
                <Link to="/forgot-password" className="text-xs text-pix-pink hover:text-pix-pink-dark transition-colors">
                  Forgot password?
                </Link>
              </div>
              <input
                id="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 block w-full rounded-lg border border-white/10 bg-pix-void px-3 py-2.5 text-sm text-white placeholder-white/20 focus:border-pix-pink/50 focus:outline-none focus:ring-1 focus:ring-pix-pink/50"
              />
            </div>

            {error && (
              <p className="rounded-lg border border-red-500/20 bg-red-500/10 px-3 py-2 text-sm text-red-400">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-lg bg-pix-pink px-4 py-2.5 text-sm font-semibold text-white shadow-[0_0_20px_rgba(233,30,140,0.2)] hover:bg-pix-pink-dark disabled:opacity-50 transition-colors"
            >
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        </GlowCard>

        <p className="mt-6 text-center text-sm text-white/30">
          No account?{' '}
          <Link to="/signup" className="font-medium text-pix-pink hover:text-pix-pink-dark transition-colors">
            Create one
          </Link>
        </p>
      </div>
    </div>
  );
}
